import { render, staticRenderFns } from "./DeliveryAreaFeeAddForm.vue?vue&type=template&id=8a584be4&"
import script from "./DeliveryAreaFeeAddForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryAreaFeeAddForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports